'use strict';

import Loading from '~/components/Loading';

const PhoneInput = React.lazy(() => import('~/components/PhoneInput'));
const FormInput = React.lazy(() => import('~/components/FormInput'));
const FormAgreement = React.lazy(() => import('~/components/FormAgreement'));

export default function AuthRegisterForm({
    scenario,
    email,
    lastname,
    firstname,
    thirdname,
    company,
    regNumber,
    vatNumber,
    address,
    errors,
    agreeCb,
    agreeMedia,
    phone,
    phoneCode,
    onPhoneChange,
    onPhoneCodeChange,
    onPhoneCompleteChange,
    onEmailChange,
    onLastnameChange,
    onFirstnameChange,
    onThirdnameChange,
    onCompanyChange,
    onRegNumberChange,
    onVatNumberChange,
    onAddressChange,
    onAgreeChange,
    onAgreeMediaChange,
    onSubmit,
    onGoLogin,
    secondaryKey,
    separatorKey,
    requireMediaAgreement,
    agencyAgreementTextKey,
    firstNameFirst,
}) {
    const canSubmit = requireMediaAgreement ? (agreeCb && agreeMedia) : agreeCb;

    // Порядок полей имени различается по брендам — сохраняем как было.
    const firstNameRow = (
        <div className="reg-modal__row">
            <React.Suspense fallback={<Loading active={true} />}>
                <FormInput
                    className={'reg-input'}
                    label={__('[Registration][Form] First name')}
                    value={firstname}
                    error={errors.firstname}
                    onChange={onFirstnameChange}
                />
            </React.Suspense>
        </div>
    );
    const lastNameRow = (
        <div className="reg-modal__row">
            <React.Suspense fallback={<Loading active={true} />}>
                <FormInput
                    className={'reg-input'}
                    label={__('[Registration][Form] Last name')}
                    value={lastname}
                    error={errors.lastname}
                    onChange={onLastnameChange}
                />
            </React.Suspense>
        </div>
    );

    return (
        <div>
            <div className="reg-modal__title">
                {__('[Registration] Title')}
            </div>
            <div className="reg-modal__row">
                <React.Suspense fallback={<Loading active={true} />}>
                    <PhoneInput
                        className={'reg-input'}
                        label={__('[Registration][Form] Phone')}
                        value={phone}
                        phoneCode={phoneCode}
                        error={errors.phone}
                        autoFocus={true}
                        onChange={(phoneValue, phoneCompleteValue) => onPhoneChange(phoneValue, phoneCompleteValue)}
                        onCodeChange={onPhoneCodeChange}
                        onCompleteChange={onPhoneCompleteChange}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__row">
                <React.Suspense fallback={<Loading active={true} />}>
                    <FormInput
                        className={'reg-input'}
                        label={__('[Registration][Form] Email')}
                        value={email}
                        error={errors.email}
                        onChange={onEmailChange}
                    />
                </React.Suspense>
            </div>
            {firstNameFirst ? <React.Fragment>{firstNameRow}{lastNameRow}</React.Fragment> : <React.Fragment>{lastNameRow}{firstNameRow}</React.Fragment>}
            {lang === 'ru' && <div className="reg-modal__row">
                <React.Suspense fallback={<Loading active={true} />}>
                    <FormInput
                        className={'reg-input'}
                        label={__('[Registration][Form] Middle name')}
                        value={thirdname}
                        error={errors.thirdname}
                        onChange={onThirdnameChange}
                    />
                </React.Suspense>
            </div>}
            {scenario !== 'client' && <div>
                <div className="reg-modal__row">
                    <React.Suspense fallback={<Loading active={true} />}>
                        <FormInput
                            className={'reg-input'}
                            label={__('[Registration][Form] Company name')}
                            value={company}
                            error={errors.company}
                            onChange={onCompanyChange}
                        />
                    </React.Suspense>
                </div>
                {lang !== 'ru' && <div>
                    <div className="reg-modal__row">
                        <React.Suspense fallback={<Loading active={true} />}>
                            <FormInput
                                className={'reg-input'}
                                label={__('[Registration][Form] Company registration number')}
                                value={regNumber}
                                error={errors.reg_number}
                                onChange={onRegNumberChange}
                            />
                        </React.Suspense>
                    </div>
                    <div className="reg-modal__row">
                        <React.Suspense fallback={<Loading active={true} />}>
                            <FormInput
                                className={'reg-input'}
                                label={__('[Registration][Form] VAT number')}
                                value={vatNumber}
                                error={errors.vat_number}
                                onChange={onVatNumberChange}
                            />
                        </React.Suspense>
                    </div>
                    <div className="reg-modal__row">
                        <React.Suspense fallback={<Loading active={true} />}>
                            <FormInput
                                className={'reg-input'}
                                label={__('[Registration][Form] Full address')}
                                value={address}
                                error={errors.address}
                                onChange={onAddressChange}
                            />
                        </React.Suspense>
                    </div>
                </div>}
            </div>}
            {errors.server && <div className="error-message">{errors.server}</div>}
            <div className="reg-checkbox">
                <React.Suspense fallback={<Loading active={true} />}>
                    <FormAgreement
                        showCheckboxMedia={requireMediaAgreement}
                        agreeConditionsValue={agreeCb}
                        onAgreeConditionsChange={onAgreeChange}
                        agreeMediaValue={agreeMedia}
                        onAgreeMediaChange={onAgreeMediaChange}
                        textConditions={scenario === 'agency' ? agencyAgreementTextKey && __(agencyAgreementTextKey) : undefined}
                    />
                </React.Suspense>
            </div>
            <div className="reg-modal__btns">
                <button className={cn('button button-round', !canSubmit && 'disabled')} onClick={onSubmit}>
                    {__('[Registration] Next')}
                </button>

                {separatorKey && <div className="reg-modal__separator">
                    <span>{__(separatorKey)}</span>
                </div>}
            </div>
            <a className="button button-round-white" onClick={onGoLogin}>
                {__(secondaryKey)}
            </a>
        </div>
    );
}
